module.exports = {"310114001":"新成路街道","310114002":"真新街道","310114003":"菊园新区管委会","310114004":"嘉定镇街道","310114102":"南翔镇","310114103":"安亭镇","310114106":"马陆镇","310114109":"徐行镇","310114111":"华亭镇","310114114":"外冈镇","310114118":"江桥镇","310114501":"嘉定工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310114.json
// module id = 819
// module chunks = 0